import React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import messages from '../../../res/translations/messages';

class PrintButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.print = this.onPrint.bind(this);
    }

    onPrint() {
        window.print();
    }

    render() {
        const {disabled} = this.props;
        return (
            <div className="btn-group">
                <button type="button" className={classNames('btn btn-primary')} disabled={disabled} onClick={this.onPrint}>
                    <FontAwesomeIcon icon="print" fixedWidth /> <FormattedMessage {...messages.surveys.button.print} />
                </button>
            </div>
        );
    }
}

export default PrintButton;
